
/* styles */
require("!!./../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?sourceMap!./../../node_modules/vue-loader/lib/style-rewriter?id=data-v-69ac242e&scoped=true!./../../node_modules/vue-loader/lib/selector?type=styles&index=0!./Testimonials.vue")

var Component = require("!./../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./../../node_modules/vue-loader/lib/selector?type=script&index=0!./Testimonials.vue"),
  /* template */
  require("!!./../../node_modules/vue-loader/lib/template-compiler?id=data-v-69ac242e!./../../node_modules/vue-loader/lib/selector?type=template&index=0!./Testimonials.vue"),
  /* scopeId */
  "data-v-69ac242e",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/pages/Testimonials.vue
// module id = 461
// module chunks = 1